import React from 'react'
import { useDispatch } from 'react-redux'
import { useSettingsPopupState } from '../hooks'
import { CustomFormPopup } from '../CustomFormPopup'
import { ModalDescriptorForType } from '../../../store/modals'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { useAddDocumentMutation } from '../../../features/knowledgeBase'

type Props = {
  modalDescriptor: ModalDescriptorForType<'knowledge_base_upload_document'>
}

type File = {
  filename: string
  relativePath: string
  data: string
}

const schema = {
  type: 'object',
  properties: {
    path: { type: 'string', title: 'Path' },
    files: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          filename: { type: 'string', title: 'Filename' },
          relativePath: { type: 'string', title: 'Relative Path' },
          data: { type: 'string', title: 'Data', format: 'data-url' }
        }
      },
      title: 'Files'
    }
  }
}

const uiSchema = {
  files: {
    'ui:widget': 'FileUploadWidget',
    'ui:options': { accept: '.md' }
  }
}

export const KnowledgeBaseUploadDocumentPopup: React.FC<Props> = ({ modalDescriptor }) => {
  const { path, botId, modelId } = modalDescriptor
  const initialFormData = {
    path: path,
    files: []
  }

  const dispatch = useDispatch()

  const { formData, onFormDataChange } = useSettingsPopupState(
    () => initialFormData,
    [modalDescriptor]
  ) as any
  const [addDocument] = useAddDocumentMutation()
  const close = () => dispatch(modalsActions.closeModal())

  return (
    <CustomFormPopup
      title="Upload document"
      formData={formData}
      onChange={onFormDataChange}
      labels={{ buttons: { submit: 'Upload document' } }}
      onSubmit={formData => {
        const trimmedPath = (formData?.path?.trim() || '') as string

        if (formData?.files.length > 0) {
          const filesWithCombinedPaths = formData.files.map(
            ({ data, filename, relativePath }: File) => {
              const prefixedPath = trimmedPath + relativePath
              return { data, filename, path: prefixedPath }
            }
          )
          addDocument({ botId, modelId, files: filesWithCombinedPaths })
          close()
        }
      }}
      schema={schema}
      uiSchema={uiSchema}
      validateSchema={(formData, errors) => {
        if (formData?.path?.startsWith('/')) {
          errors?.path?.addError('Path should not start with a slash (/).')
        }
        if (formData?.path?.endsWith('/')) {
          errors?.path?.addError('Path should not end with a slash (/).')
        }

        return errors
      }}
    />
  )
}
